import React from "react";
import { useQuery } from "@apollo/react-hooks";

import { httpClient } from "../../../settings/apolloClient";
import SILO_LOCATIONS_QUERY from "../graphql/queries/siloLocationsQuery";
import SilosPanel from "./SilosPanel";
import { hasMonitoredSilo } from "./SiloLevels";

// Owns SILO_LOCATIONS_QUERY, which reads monitorSensor.lastMeasurement — a value
// patched live in the cache. Keeping it here means a silo level update only
// re-renders this panel, not the plant diagram. cache-and-network paints the
// last level instantly on remount.
const SilosSection = () => {
  const { data } = useQuery(SILO_LOCATIONS_QUERY, {
    fetchPolicy: "cache-and-network",
    client: httpClient,
  });

  const { siloLocations } = data || {};

  if (!hasMonitoredSilo(siloLocations)) return null;

  return <SilosPanel locations={siloLocations} />;
};

export default SilosSection;
